import {
  LOAN_DETAIL_CHANGED,
  UPDATE_LOAN_DETAIL_START,
  UPDATE_LOAN_DETAIL_SUCCESS,
  UPDATE_LOAN_DETAIL_FAILURE,
  UPDATE_LOAN_DETAIL_CALCULATOR,
} from './types';

export const loanDetailChanged = (payload) => ({
  type: LOAN_DETAIL_CHANGED,
  payload: payload,
})

export const updateLoanDetailStart = (payload) => ({
  type: UPDATE_LOAN_DETAIL_START,
  payload: payload,
})

export const updateLoanDetailSuccess = (payload) => ({
  type: UPDATE_LOAN_DETAIL_SUCCESS,
  payload: payload,
})

export const updateLoanDetailFailure = (payload) => ({
  type: UPDATE_LOAN_DETAIL_FAILURE,
  payload: payload,
})

export const updateLoanDetailCalculator = (payload) => ({
  type: UPDATE_LOAN_DETAIL_CALCULATOR,
  payload: payload,
})
